import React, { useState, useEffect } from 'react'

import cn from 'classnames'
import { CardDropOff } from '@foodsby/nutrient-v3'
import { Link } from 'react-router-dom'
import { api, FOODSBY_BASE_URL } from '../../api/api'
import { format, subDays } from 'date-fns'
import { formatUrl } from '../../util/formatUtils'
import { placeOrderRoute } from '../../routes/routes'

export const dayFormat = 'D'
export const timeFormat = 'HHmm'

const date = new Date()
const isLimitedOrders = delivery =>
  delivery.weightLeft < 7 && delivery.weightLeft > 0
const isSoldOut = delivery => delivery.weightLeft <= 0
const isNearCutOff = delivery =>
  format(delivery.cutoffDate, timeFormat) - format(date, timeFormat) < 16 &&
  format(delivery.cutoffDate, timeFormat) - format(date, timeFormat) > 0 &&
  Number(format(delivery.cutoffDate, dayFormat)) === date.getDate()

const Delivery = ({ locationId, selectDelivery, selectedDate, deliveries }) => {
  const [friendsOrdered, setFriendsOrdered] = useState(null)
  const getFriendsOrdered = async (storeIds, fromDate, toDate) => {
    const res = await api.get(
      `${FOODSBY_BASE_URL}/api/v1/connections/friends/orders/stores?storeIds=${storeIds}&fromDate=${fromDate}&toDate=${toDate}`,
      null,
      { cache: true },
    )
    setFriendsOrdered(res.friendsOrderedFromDate)
  }

  useEffect(() => {
    const onDate = format(subDays(selectedDate, 0), 'YYYY-MM-DD')
    const storeIds = deliveries.map(d => d.storeId)

    getFriendsOrdered(storeIds, onDate, onDate)
  }, [deliveries]) //eslint-disable-line

  return (
    <>
      {deliveries.map(delivery => {
        return (
          <div key={delivery.deliveryId}>
            {isSoldOut(delivery) || delivery.isPastCutoff ? (
              <CardDropOff
                classNames={cn('NutrientV3', {
                  'is-limitedOrders':
                    isLimitedOrders(delivery) &&
                    !isSoldOut(delivery) &&
                    !delivery.isPastCutoff,
                  'is-new': delivery.isNewRestaurantAtLocation,
                  'is-soldOut': isSoldOut(delivery) && !delivery.isPastCutoff,
                  'is-nearCutOff':
                    isNearCutOff(delivery) &&
                    !isSoldOut(delivery) &&
                    !delivery.isPastCutoff,
                  'is-tooLate': delivery.isPastCutoff,
                })}
                friendImageUrlBase={process.env.REACT_APP_IMAGE_LAMBDA}
                friendsOrdered={
                  friendsOrdered?.find(f => f.storeId === delivery.storeId)
                    ?.friendsOrdered
                }
                ordersRemaining={delivery.weightLeft}
                restaurantDetails={{
                  logo: delivery.logoUrl,
                  restaurantName: delivery.restaurantName,
                  cutoffTime: delivery.cutoffDate,
                  deliverTime: delivery.dropoffDate,
                }}
              ></CardDropOff>
            ) : (
              <Link
                className={cn({
                  'Link--is-inActive':
                    isSoldOut(delivery) || delivery.isPastCutoff,
                })}
                onClick={() => selectDelivery(delivery)}
                style={{ marginBottom: '16px', width: '100%' }}
                to={formatUrl(placeOrderRoute.path, {
                  locationId: locationId,
                  dropoffId: delivery.deliveryDropoffId,
                })}
              >
                <CardDropOff
                  classNames={cn('NutrientV3', {
                    'is-limitedOrders':
                      isLimitedOrders(delivery) &&
                      !isSoldOut(delivery) &&
                      !delivery.isPastCutoff,
                    'is-new': delivery.isNewRestaurantAtLocation,
                    'is-soldOut': isSoldOut(delivery) && !delivery.isPastCutoff,
                    'is-nearCutOff':
                      isNearCutOff(delivery) &&
                      !isSoldOut(delivery) &&
                      !delivery.isPastCutoff,
                    'is-tooLate': delivery.isPastCutoff,
                  })}
                  friendImageUrlBase={process.env.REACT_APP_IMAGE_LAMBDA}
                  friendsOrdered={
                    friendsOrdered?.find(f => f.storeId === delivery.storeId)
                      ?.friendsOrdered
                  }
                  ordersRemaining={delivery.weightLeft}
                  restaurantDetails={{
                    logo: delivery.logoUrl,
                    restaurantName: delivery.restaurantName,
                    cutoffTime: delivery.cutoffDate,
                    deliverTime: delivery.dropoffDate,
                  }}
                ></CardDropOff>
              </Link>
            )}
          </div>
        )
      })}
    </>
  )
}

export default Delivery
